import apiService from "./apiService";

const userService = {
    async searchUsers(searchModel) {
        try {
            return (await apiService.get(`u/search`, searchModel, true)).data;
        }
        catch {
            return [];
        }
    },
    async searchUserExpenditures(searchModel) {
        try {
            return (await apiService.get(`banker/get-user-spending-summary`, searchModel, true)).data;
        }
        catch {
            return [];
        }
    },
    async searchLeaders(brgyids,keyword) {
        try {
            return (await apiService.post(`u/getleaders`, {brgyids: brgyids ,name_voter: keyword}, true)).data;
        }
        catch {
            return [];
        }
    },
    async searchClusters(brgyids,keyword) {
        try {
            return (await apiService.post(`u/getclusters`, {brgyids: brgyids ,watcher_voter: keyword}, true)).data;
        }
        catch {
            return [];
        }
    },
    async generateTaggerReport(cityid,range,dtrange){
        try {
            return (await apiService.get(`u/generate-tagger-report/${cityid}/${range}`, dtrange, true)).data;
        }
        catch {
            return [];
        }
    },
    async generateTaggerBillingByBrgy(brgyid){
        try {
            return (await apiService.get(`u/generate-tagger-billing/${brgyid}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async unbindDevice(userid){
        try {
            return (await apiService.get(`u/unbind-device/${userid}`, {}, true)).data;
        }
        catch {
            return {success: false, message: "An error occured while processing the request."};
        }
    },
    
    async searchUserLogs(page, searchModel) {
        try {
            return (await apiService.get(`u/search-logs/${page}`, searchModel, true)).data;
        }
        catch {
            return [];
        }
    },
    async searchActivationLogs(page, searchModel) {
        try {
            return (await apiService.get(`u/search-verifications/${page}`, searchModel, true)).data;
        }
        catch {
            return [];
        }
    },
    async toggleVerifiedStatus(id, state) {
        try {
            return (await apiService.post(`u/toggleverification/${id}/${state}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async toggleUser(params) {
        try {
            return (await apiService.post(`u/toggle/${params.id}/${params.state}`, {}, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
    async revealPassword(id) {
        try {
            return (await apiService.post(`u/reveal/${id}`, {}, true)).data;
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
    async saveUserAssignments(user) {
        try {
            return (await apiService.post(`u/saveuserassignments`, {
                syspk_user: user.syspk_user, assignedbrgyids_user: user.assignedbrgyids_user, pcrole_user: user.pcrole_user,
                name_user: user.name_user, fullname_user: user.fullname_user, mobileno_user: user.mobileno_user, pword_user: user.pword_user, assignedcityids_user: user.assignedcityids_user,
                 cityid_user: user.cityid_user, tag_user: user.tag_user,
                assigned_groups: user.assigned_groups, assigned_clusters: user.assigned_clusters
            }, true)).data
        }
        catch {
            return { success: false, message: "An error occured while processing the request." };
        }
    },
    async getRecentLogs() {
        try {
            return (await apiService.get(`u/getrecentlogs`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async getLastKnownLocation(id) {
        try {
            return (await apiService.get(`u/getlastknownlocation/${id}`, {}, true)).data;
        }
        catch {
            return { lastKnownLocation: { syspk_loc: 0, id: 0, userid_loc: 0, lat_loc: 0, lng_loc: 0, accuracy_loc: 0, timestamp_loc: "0001-01-01T00:00:00" },
        scannerAssignments: []};
        }
    },
    async getPaginatedUsers(id, page, rows) {
        try {
            return (await apiService.get(`u/paginated-users/${id}/${page}/${rows}`)).data;
        }
        catch {
            return [];
        }
    },

    async getActions() {
        try {
            return (await apiService.get(`u/get-actions`, {}, true)).data;
        }
        catch {
            return [];
        }
    },

    async toggleAction(id, state) {
        try {
            return (await apiService.post(`u/toggle-action/${id}/${state}`, {}, true)).data;
        }
        catch {
            return [];
        }
    },
    async submitLogin(credentials){
        try {
            return (await apiService.post(`u/submitlogin/`, credentials, false)).data;
        }
        catch {
            return {success: false, message: "An error occured while processing the request"};
        }
    }
};

export default userService;